import * as React from "react"

import { cn } from "@/lib/utils"
import { useIsReadOnly } from "@/contexts/ReadOnlyContext"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    // Read-only regions (e.g. production mode) make the field non-editable while
    // keeping its value legible and selectable. An explicit prop always wins.
    const inReadOnlyRegion = useIsReadOnly()
    const readOnly = props.readOnly ?? inReadOnlyRegion
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          readOnly && "cursor-default border-transparent bg-muted/50 focus-visible:ring-0 focus-visible:ring-offset-0",
          className
        )}
        ref={ref}
        {...props}
        readOnly={readOnly}
        data-readonly={readOnly || undefined}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
